import TenantMembershipPermissionsEnum from 'shared/models/enum/TenantMembershipPermissionsEnum'
import TenantModulesEnum from 'shared/models/enum/TenantModulesEnum'

export const moduleRoleEnum = {
	admin: 'Admin',
	staff: 'Staff',
	vaultTechnician: 'Vault Technician',
	projectTechnician: 'Project Technician',
	fieldCollector: 'Field Collector',
}

/**
 * get the role of the user for each module
 * @param {[typeof TenantMembershipPermissionsEnum]} permissions
 * @returns {{
 *  systemManagement: 'Admin' | 'Staff' | null,
 *  toManagement: 'Admin' | null,
 *  revenueManagement: 'Admin' | 'Staff' | null,
 * 	collections: 'Admin' | 'Vault Technician' | 'Project Technician' | 'Field Collector' | null,
 * }}
 */
const getModulesRole = permissions => {
	if (!permissions) return {}

	return {
		[TenantModulesEnum.SYSTEM_MANAGEMENT]: permissions.includes(
			TenantMembershipPermissionsEnum.ETI_ADMIN,
		)
			? moduleRoleEnum.admin
			: permissions.includes(TenantMembershipPermissionsEnum.ETI_STAFF)
			? moduleRoleEnum.staff
			: null,
		[TenantModulesEnum.TO_MANAGEMENT]: permissions.includes(
			TenantMembershipPermissionsEnum.TO_ADMIN,
		)
			? moduleRoleEnum.admin
			: null,
		[TenantModulesEnum.REVENUE]: permissions.includes(TenantMembershipPermissionsEnum.REVENUE_ADMIN)
			? moduleRoleEnum.admin
			: permissions.includes(TenantMembershipPermissionsEnum.REVENUE_STAFF)
			? moduleRoleEnum.staff
			: null,
		[TenantModulesEnum.COLLECTIONS]: permissions.includes(
			TenantMembershipPermissionsEnum.COLLECTIONS_ADMIN,
		)
			? moduleRoleEnum.admin
			: permissions.includes(TenantMembershipPermissionsEnum.COLLECTIONS_VAULT_TECHNICIAN)
			? moduleRoleEnum.vaultTechnician
			: permissions.includes(TenantMembershipPermissionsEnum.COLLECTIONS_PROJECT_TECHNICIAN)
			? moduleRoleEnum.projectTechnician
			: permissions.includes(TenantMembershipPermissionsEnum.COLLECTIONS_FIELD_COLLECTOR)
			? moduleRoleEnum.fieldCollector
			: null,
	}
}

export default getModulesRole
